import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getAttributes, isStructTreeNode, isStructTreeNodeWithOnlyContentChild } from './shared/structTreeUtils.js';
export default function StructTreeItem(_ref) {
  var className = _ref.className,
    node = _ref.node;
  var attributes = useMemo(function () {
    return getAttributes(node);
  }, [node]);
  var children = useMemo(function () {
    if (!isStructTreeNode(node)) {
      return null;
    }
    if (isStructTreeNodeWithOnlyContentChild(node)) {
      return null;
    }
    return node.children.map(function (child, index) {
      return (
        // biome-ignore lint/suspicious/noArrayIndexKey: index is stable here
        _jsx(StructTreeItem, {
          node: child
        }, index)
      );
    });
  }, [node]);
  return _jsx("span", Object.assign({
    className: className
  }, attributes, {
    children: children
  }));
}